import script from "./buildGroupsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./buildGroupsTable.vue?vue&type=script&setup=true&lang=ts"

import "./buildGroupsTable.vue?vue&type=style&index=0&id=054c19b0&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054c19b0"]])

export default __exports__